"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Biller = void 0;
const BillerRocketGate = 1;
const BillerCCBill = 2;
const BillerEpoch = 3;
const BillerGoCoin = 4;
const BillerBitPay = 5;
const BillerInternal = 6;
const BillerNats = 7;
const BillerVservices = 8;
const BillerPayGarden = 9;
const BillerCoinPayments = 10;
const BillerCommerceGate = 11;
const BillerCheckMoneyOrder = 12;
exports.Biller = {
    RocketGate: BillerRocketGate,
    CCBill: BillerCCBill,
    Epoch: BillerEpoch,
    GoCoin: BillerGoCoin,
    BitPay: BillerBitPay,
    Internal: BillerInternal,
    Nats: BillerNats,
    VServices: BillerVservices,
    PayGarden: BillerPayGarden,
    CoinPayments: BillerCoinPayments,
    CommerceGate: BillerCommerceGate,
    CheckMoneyOrder: BillerCheckMoneyOrder,
};
